export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["SUBMIT_ACTION"] = "SUBMIT_ACTION";
    ACTION["UPLOAD_DOCUMENTS_ACTON"] = "UPLOAD_DOCUMENTS_ACTON";
    ACTION["PROCEED_TO_NEXT_STEP"] = "PROCEED_TO_NEXT_STEP";
    ACTION["CONTINUE_ACTION"] = "CONTINUE_ACTION";
})(ACTION || (ACTION = {}));
